<template lang="pug">
  shListData(title="Refunds History" resolver="refundsHistory" keyData="_id" component="shRefund" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'RefundsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/refund/RefundsHistory.vue